module.exports = {
    "isAnimation": true,
    "isLoop": true,
    "frames": [
        {
            "time": 0,
            "image": require("./z_hover_0000.png").default
        },
        {
            "time": 500,
            "image": require("./z_hover_0500.png").default
        },
        {
            "time": 700,
            "image": require("./z_hover_0700.png").default
        },
        {
            "time": 800,
            "image": require("./z_hover_0800.png").default
        },
        {
            "time": 1000,
            "image": require("./z_hover_1000.png").default
        },
        {
            "time": 1200,
            "image": require("./z_hover_1200.png").default
        },
        {
            "time": 1300,
            "image": require("./z_hover_1300.png").default
        },
        {
            "time": 1400,
            "image": require("./z_hover_1400.png").default
        },
        {
            "time": 1500,
            "image": require("./z_hover_1500.png").default
        },
    ]
}
